import { Input, InputProps } from '@chakra-ui/react';
import { InputVariant } from 'presentation/theme/components/input';
import { FC } from 'react';

const TextInput: FC<InputProps> = (props) => {
  return <Input variant={InputVariant.filled} {...props} />;
};

export default TextInput;
